import React, { ReactNode, Component } from 'react';
import Alert from 'react-bootstrap/esm/Alert';
import './AuthLayout.scss';

interface AuthLayoutProps {
  tip?: string|JSX.Element;
  className?: string;
}

export class AuthLayout extends Component<AuthLayoutProps> {
  render(): ReactNode {
    const { children, tip, className } = this.props;
    const fullClassNameMainContent = `auth-layout__main-content ${className || ''}`;
    return (
      <div className="container-auth-layout">
        <div className="auth-layout">
          <div className={fullClassNameMainContent}>
            <h1 className="auth-layout__title"><div className="auth-layout__logo" />MijnTOPP</h1>
            { tip && <Alert variant="warning" className="auth-layout__tip">{tip}</Alert> }
            {children}
          </div>
        </div>
      </div>
    );
  }
}
